import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

export default function FieldDetail({ label, value }) {
  if (!value) {
    return null;
  }

  return (
    <Grid
      item
      md={4}
      xs={12}
    >
      <Stack
        direction="column"
        gap="8px"
      >
        <Text
          color="secondary"
          size="xs"
          uppercase
        >
          {label}
        </Text>
        <Text
          color="primary"
          size="md"
        >
          {value}
        </Text>
      </Stack>
    </Grid>
  );
}

FieldDetail.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string
};
